import { render, staticRenderFns } from "./ProfileDocumentUpload.vue?vue&type=template&id=6bfb7641&scoped=true"
import script from "./ProfileDocumentUpload.vue?vue&type=script&lang=js"
export * from "./ProfileDocumentUpload.vue?vue&type=script&lang=js"
import style0 from "./ProfileDocumentUpload.vue?vue&type=style&index=0&id=6bfb7641&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfb7641",
  null
  
)

export default component.exports